import apiClient from 'utilities/apiClient';

export const receivedGift_getbyId = (url, payload) => {
  return apiClient.get(
    `${apiClient.Urls.receivedGift_getbyId}/${url}`,
    payload,
    true
  );
};
